var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"my-1"},[_c('b-link',{attrs:{"to":_vm.to}},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":_vm.icon}}),_vm._v(_vm._s(_vm.title)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }